module.exports = new __parcel__URL__("seal01.dec44b94.png").toString();